import React, { useState } from "react";
import { useLocation, useOutletContext } from "react-router";
import RecallShotclassesForm from "./RecallShotclassesForm/RecallShotclassesForm";
import RecallSelectiveForm from "./RecallSelectiveForm/RecallSelectiveForm";
import { recallShotclasses } from "../../../utils/mainTabs/distribute/recallShotclasses";

const RecallShotclasses = () => {
  const location = useLocation();
  const { tenantName } = useOutletContext();
  const [selectedSearchShotclassData, setselectedSearchShotclassData] =
    useState(null);
  const [selectedUserClassAndNameObj, setSelectedUserClassAndNameObj] =
    useState({ class: { classId: 0, userId: 0 } });
  const [recallShotclassesSearchClick, setRecallShotclassesSearchClick] =
    useState(0);

  return (
    <>
      {location?.pathname === recallShotclasses?.path(tenantName) ? (
        <RecallShotclassesForm
          selectedSearchShotclassData={selectedSearchShotclassData}
          setselectedSearchShotclassData={setselectedSearchShotclassData}
          tenantName={tenantName}
          setSelectedUserClassAndNameObj={setSelectedUserClassAndNameObj}
          selectedUserClassAndNameObj={selectedUserClassAndNameObj}
          recallShotclassesSearchClick={recallShotclassesSearchClick}
          setRecallShotclassesSearchClick={setRecallShotclassesSearchClick}
        />
      ) : (
        <RecallSelectiveForm
          selectedSearchShotclassData={selectedSearchShotclassData}
          setselectedSearchShotclassData={setselectedSearchShotclassData}
          tenantName={tenantName}
          setSelectedUserClassAndNameObj={setSelectedUserClassAndNameObj}
          selectedUserClassAndNameObj={selectedUserClassAndNameObj}
          setRecallShotclassesSearchClick={setRecallShotclassesSearchClick}
        />
      )}
    </>
  );
};

export default RecallShotclasses;
